import { LOGIN_USER, LOGOUT_USER } from "../types";

export default (state, action) => {
  switch (action.type) {
    case LOGIN_USER:
      return { ...state, userInfo: action.payload, isLoggedIn: true };
    case LOGOUT_USER:
      return { ...state, isLoggedIn: false, userInfo: null };
    default:
      return { ...state };
  }
};
